// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"195dce01","453":"6b56c807","726":"63452396"}[chunkId] + ".chunk.js";
};